import { defineMessages } from 'react-intl';

export default defineMessages({
  waitMessage: {
    id: 'components.atom.baseloader.pleaseWait',
    defaultMessage: 'Please wait',
  },
});
